import type { ReactNode } from "react";

/** Surface card — white background, hairline border, large radius. */
export default function Card({
  shadow = false,
  className = "",
  children,
}: {
  shadow?: boolean;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div
      className={`rounded-ref-lg border border-line bg-surface ${shadow ? "shadow-ref" : ""} ${className}`}
    >
      {children}
    </div>
  );
}
